import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import './scss/App.scss'
import Main from "./pages/Main";
import Teams from "./pages/Teams.jsx";
import Services from "./pages/Services.jsx";
import EmployeeProfile from "./components/EmployeeProfile/EmployeeProfile.jsx";
import qs from "qs";
import axios from "axios";

function App() {
    const [activeCategory, setActiveCategory] = useState('corporatePractice');
    const [isHidden, setIsHidden] = useState(false);


    const url = "https://sqn-law.ru:3001"
    const [teamsData, setTeamsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const fetchData = async (page = 1) => {
            try {
                const response = await axios.get(
                    `${url}/api/teams?pagination[page]=${page}&pagination[pageSize]=100&fields[0]=firstName&fields[1]=lastName&fields[2]=phoneNumber&fields[3]=email&fields[4]=description&fields[5]=position&populate[userAvatar][fields][0]=url&populate[userAvatar][fields][1]=name`,
                );
                const data = response.data.data;
                if (data.length > 0) {
                    setTeamsData(prevData => [...prevData, ...data]);
                    fetchData(page + 1);
                } else {
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Ошибка при запросе данных:", error);
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);
    return (
        <>
            <Routes>
                <Route path="/" element={<Main activeCategory={activeCategory} setActiveCategory={setActiveCategory}/>}/>
                <Route path="/team" element={<Teams setActiveCategory={setActiveCategory} teamsData={teamsData}/>}/>
                <Route path="/services" element={<Services teamsData={teamsData} isHidden={isHidden} setIsHidden={setIsHidden} activeCategory={activeCategory} setActiveCategory={setActiveCategory}/>}/>
                <Route path="/team/:nameEmplo" element={<EmployeeProfile teamsData={teamsData}/>}/>
            </Routes>
        </>);
}

export default App;
